import SubscriberActivitiesStore from './SubscriberActivitiesStore';
import DocumentScanSchedulerActivityStore from './DocumentScanSchedulerActivityStore';

export default class ActivityRootStore {
  constructor(parentStore) {
    this.parentStore = parentStore;

    this.subscriberActivitiesStore = new SubscriberActivitiesStore(this);
    this.documentScanSchedulerActivityStore = new DocumentScanSchedulerActivityStore(this);
  }
}
